import React from 'react';
import Hero from './components/administration/cell-coordinators/Hero';
import Main from './components/administration/cell-coordinators/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const CellCoordinators = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default CellCoordinators;